module.exports = __webpack_public_path__ + "static/media/laps.15f8c4d8.png";